document.addEventListener('click', function (event) {
  const buyNowBtn = event.target.closest('.accelerated-checkout-button');
  if (!buyNowBtn) return;

  event.preventDefault();

  // Buscar el formulario del producto
  const formId = buyNowBtn.getAttribute('data-form-id');
  let productForm = formId ? document.getElementById(formId) : null;

  if (!productForm) {
    productForm = buyNowBtn.closest('section')?.querySelector('form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  if (!productForm) return;

  const formData = new FormData(productForm);

  // Agregar el producto al carrito por AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Error al agregar al carrito');
      return response.json();
    })
    .then(function () {
      // En cuanto se agrega, ir directo al checkout
      window.location.href = '/checkout';
    })
    .catch(function () {
      // Si algo falla, por lo menos ir al carrito
      window.location.href = '/cart';
    });
});
